<template lang="html">
  <pl-dialog
    @close="$emit('close')"
    padding="0px"
    borderRadius="11px"
    :width="'598px'"
    :height="'452px'"
    class="modal-background-connected"
  >
    <div class="top-container start-xs ml3">
      <pl-button @click.native="$emit('close')" class="pl-primary-font">
        <i class="fa fa-arrow-left pr2" />
        <span class="f5">Back</span>
      </pl-button>
    </div>
    <div
      class="flex flex-nowrap flex-grow items-center justify-center body-container"
    >
      <div class="f6 fw6 center-xs mt5 ph4 text-content">
        You can only connect the RoundTable to one LMS assignment at a time.
      </div>
    </div>
    <div class="mt4 center-xs">
      <img :src="integration_connected.provider_icon_url" height="60px" />
    </div>
    <div class="mt4">
      <div class="row no-margin button-row center-xs">
        <pl-button class="pl-ruby fw6" @click.native="disconnectIntegration">
          DISCONNECT
        </pl-button>
      </div>
    </div>

    <disconnect-assignment-modal
      v-if="show_disconnect_integration_modal"
      :integrationToDisconnect="integration_connected"
      @close="show_disconnect_integration_modal = false"
    />
  </pl-dialog>
</template>
<script lang="babel">
  import { mapGetters } from 'vuex';
    import disconnectAssignmentModal from 'components/modals/disconnectAssignmentModal';
     export default {
        components: {
          disconnectAssignmentModal
        },
        data() {
          return{
            show_disconnect_integration_modal: false
          };
        },
        props: {
          integration: {
            type: Object,
            default() {
              return {};
            },
          }
        },
        computed: {
          ...mapGetters([
            'getCourseDetail',
            'getCurrentRT',
            'getCurrentDiscussion',
          ]),
          integration_connected(){
            let integration_connected = {};
            if(this.integration.provider_name!=='Google Classroom'){
            integration_connected=this.getCourseDetail.edlink_integrations.find((integration)=> integration.provider_name ===this.integration.provider_name);
            }
            else{
              integration_connected=this.getCourseDetail.google_classroom_integration;
              integration_connected.provider_name='Google Classroom';
              integration_connected.provider_icon_url = '/static/admin_icons/google-classroom.png';
            }

            return integration_connected;
          }
        },
        methods:{
          disconnectIntegration()
          {
            this.show_disconnect_integration_modal = true;
          }
        }

     };
</script>
<style scoped lang="stylus">
  .top-container
    line-height: 50px
    height: 50px
  .body-container
    border-top: 2px solid #ececec;
  .text-content
    font-size: 24px
    line-height: 30px
    color: #3C3C3C
  .modal-background-connected
    background: none !important;
</style>



// WEBPACK FOOTER //
// integrationConnectedModal.vue?64d8bc18